// Enhanced global patch for cart.js compatibility - run immediately with highest priority
(function() {
  // Immediate emergency patch before anything else runs
  function emergencyPatchCartJS() {
    if (typeof CartItems !== 'undefined') {
      // Patch resetQuantityInput method
      if (CartItems.prototype.resetQuantityInput) {
        const originalReset = CartItems.prototype.resetQuantityInput;
        CartItems.prototype.resetQuantityInput = function(id) {
          try {
            const input = this.querySelector(`#Quantity-${id}`);
            if (input && input.getAttribute && typeof input.getAttribute === 'function') {
              input.value = input.getAttribute('value') || input.value;
              this.isEnterPressed = false;
            }
          } catch (e) {
            console.warn('CartJS resetQuantityInput patch error:', e);
          }
        };
      }
      
      // Patch setValidity method
      if (CartItems.prototype.setValidity) {
        const originalSetValidity = CartItems.prototype.setValidity;
        CartItems.prototype.setValidity = function(event, index, message) {
          try {
            if (event && event.target) {
              event.target.setCustomValidity(message);
              event.target.reportValidity();
              this.resetQuantityInput(index);
              // CRITICAL FIX: Only call select if it's an INPUT element with the method
              if (event.target.tagName === 'INPUT' && typeof event.target.select === 'function') {
                event.target.select();
              }
            }
          } catch (e) {
            console.warn('CartJS setValidity patch error:', e);
          }
        };
      }
    }
  }
  
  // Apply immediately
  emergencyPatchCartJS();
  
  // Store references to be patched later
  window.cartJSPatches = {
    applied: false,
    applyPatches: function() {
      if (this.applied) return;
      
      // Patch CartItems class if it exists
      if (typeof CartItems !== 'undefined') {
        // Patch resetQuantityInput
        if (CartItems.prototype.resetQuantityInput) {
          const originalReset = CartItems.prototype.resetQuantityInput;
          CartItems.prototype.resetQuantityInput = function(id) {
            try {
              const input = this.querySelector(`#Quantity-${id}`);
              if (input && input.getAttribute) {
                input.value = input.getAttribute('value');
                this.isEnterPressed = false;
              }
            } catch (e) {
              // Silently handle errors
            }
          };
        }
        
        // Patch setValidity
        if (CartItems.prototype.setValidity) {
          const originalSetValidity = CartItems.prototype.setValidity;
          CartItems.prototype.setValidity = function(event, index, message) {
            try {
              if (event && event.target) {
                event.target.setCustomValidity(message);
                event.target.reportValidity();
                this.resetQuantityInput(index);
                // Only call select if the method exists and it's an input
                if (event.target.tagName === 'INPUT' && typeof event.target.select === 'function') {
                  event.target.select();
                }
              }
            } catch (e) {
              // Silently handle errors
            }
          };
        }
        
        // Patch validateQuantity
        if (CartItems.prototype.validateQuantity) {
          const originalValidate = CartItems.prototype.validateQuantity;
          CartItems.prototype.validateQuantity = function(event) {
            try {
              if (!event || !event.target) return;
              
              // Skip validation for select elements (our variant selectors)
              if (event.target.tagName === 'SELECT') return;
              
              // Skip if during variant update
              const variantSelector = event.target.closest('cart-variant-selector');
              if (variantSelector && variantSelector.classList.contains('updating')) {
                return;
              }
              
              originalValidate.call(this, event);
            } catch (e) {
              // Silently handle errors
            }
          };
        }
        
        this.applied = true;
      }
    }
  };
  
  // Apply patches immediately if possible
  window.cartJSPatches.applyPatches();
})();

class CartVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.lineItemKey = this.dataset.lineItemKey;
    this.currentVariantId = this.dataset.currentVariantId;
    this.isUpdating = false; // Prevent concurrent updates
    
    
    this.updateOptions();
    this.initializeSwatches();
    
    // Apply patches when this component loads
    if (window.cartJSPatches) {
      window.cartJSPatches.applyPatches();
    }
  }

  initializeSwatches() {
    // Add event listeners to swatch inputs
    const swatchInputs = this.querySelectorAll('.cart-variant-swatch-input');
    swatchInputs.forEach(input => {
      input.addEventListener('change', this.onSwatchChange.bind(this));
    });
  }

  onSwatchChange(event) {
    // Prevent the change event from bubbling and triggering onVariantChange twice
    event.stopPropagation();
    // Update options array when swatch is selected
    this.updateOptions();
    // Trigger the variant change logic directly
    this.handleVariantChange();
  }

  updateOptions() {
    // Get values from both dropdowns and swatches
    const selectValues = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const swatchValues = Array.from(this.querySelectorAll('.cart-variant-swatches'), (swatchGroup) => {
      const checkedInput = swatchGroup.querySelector('.cart-variant-swatch-input:checked');
      return checkedInput ? checkedInput.value : null;
    }).filter(value => value !== null);
    
    // Combine values based on their option index
    this.options = [];
    this.querySelectorAll('.cart-variant-option').forEach((optionDiv, index) => {
      if (optionDiv.querySelector('.cart-variant-swatches')) {
        // It's a swatch option
        const checkedSwatch = optionDiv.querySelector('.cart-variant-swatch-input:checked');
        this.options[index] = checkedSwatch ? checkedSwatch.value : '';
      } else if (optionDiv.querySelector('select')) {
        // It's a dropdown option
        const select = optionDiv.querySelector('select');
        this.options[index] = select ? select.value : '';
      }
    });
  }

  onVariantChange(event) {
    // For dropdown changes
    this.updateOptions();
    this.handleVariantChange();
  }

  handleVariantChange() {
    // Prevent concurrent updates - more aggressive blocking
    if (this.isUpdating || this.classList.contains('updating')) {
      this.revertToOriginal(); // Revert any UI changes
      return;
    }
    
    this.findMatchingVariant();
    
    if (!this.selectedVariant) {
      this.showError('Variant combination not available');
      this.revertToOriginal();
      return;
    }
    
    if (!this.selectedVariant.available) {
      this.showError('This variant is currently out of stock');
      this.revertToOriginal();
      return;
    }
    
    // If same variant, do nothing
    if (this.selectedVariant.id == this.currentVariantId) {
      return;
    }
    
    this.updateCartItem();
  }

  findMatchingVariant() {
    const variants = this.getVariantData();
    // Optimize variant matching with early exit
    this.selectedVariant = variants.find((variant) => {
      // Early exit if options length doesn't match
      if (!variant.options || variant.options.length !== this.options.length) {
        return false;
      }
      
      // Check all options match - exit early on first mismatch
      for (let i = 0; i < variant.options.length; i++) {
        if (this.options[i] !== variant.options[i]) {
          return false;
        }
      }
      return true;
    });
  }

  updateCartItem() {
    // Set updating flag to prevent concurrent requests
    if (this.isUpdating) return;
    this.isUpdating = true;
    
    const cartItem = this.closest('.cart-item');
    const quantityInput = cartItem.querySelector('.quantity__input, input[name="updates[]"]');
    const currentQuantity = parseInt(quantityInput.value) || 1;
    const lineIndex = quantityInput.dataset.index;
    
    // Validate quantity against new variant rules
    const validQuantity = this.validateQuantityForVariant(currentQuantity, this.selectedVariant);
    
    this.enableLoading(lineIndex);
    this.classList.add('updating');
    
    // Use form data approach like Shopify's quantity updates
    const formData = new FormData();
    formData.append(`updates[${this.lineItemKey}]`, '0'); // Remove current item
    formData.append(`updates[${this.selectedVariant.id}]`, validQuantity.toString()); // Add new variant
    
    this.getSectionsToRender().forEach((section) => {
      formData.append('sections[]', section.section);
    });
    formData.append('sections_url', window.location.pathname);

    fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then((response) => response.text())
    .then((state) => {
      const parsedState = JSON.parse(state);

      if (parsedState.errors) {
        throw new Error(parsedState.errors);
      }

      // Update the stored current variant ID
      this.currentVariantId = this.selectedVariant.id;
      this.dataset.currentVariantId = this.selectedVariant.id;

      // Update cart sections exactly like Shopify does
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });

      this.showSuccess('Variant updated');

      // Publish cart update event
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'cart-variant-selector', 
          cartData: parsedState, 
          variantId: this.selectedVariant.id 
        });
      }

      // Wait for DOM to be fully updated before re-enabling
      this.waitForDOMUpdate().then(() => {
        this.disableLoading(lineIndex);
        this.classList.remove('updating');
        this.isUpdating = false;
      });
    })
    .catch((error) => {
      console.error('Variant update failed:', error);
      this.showError('Failed to update variant');
      this.revertToOriginal();
      
      // Re-enable immediately on error
      this.disableLoading(lineIndex);
      this.classList.remove('updating');
      this.isUpdating = false;
    });
  }


  getSectionsToRender() {
    // Cache DOM lookups for better performance
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');
    
    return [
      {
        id: 'main-cart-items',
        section: mainCartItems?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: mainCartFooter?.dataset.id,
        selector: '.js-contents',
      },
    ].filter(section => section.section); // Remove invalid sections
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  waitForDOMUpdate() {
    return new Promise(resolve => {
      // Wait for multiple animation frames to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Additional delay to ensure all cart components have updated
          setTimeout(resolve, 800);
        });
      });
    });
  }

  validateQuantityForVariant(quantity, variant) {
    if (!variant.quantity_rule) return quantity;
    
    const min = variant.quantity_rule.min || 1;
    const increment = variant.quantity_rule.increment || 1;
    const max = variant.quantity_rule.max;
    
    // Ensure minimum
    let validQty = Math.max(quantity, min);
    
    // Ensure increment
    if (increment > 1) {
      validQty = Math.ceil(validQty / increment) * increment;
    }
    
    // Ensure maximum
    if (max && validQty > max) {
      validQty = max;
    }
    
    return validQty;
  }

  getVariantData() {
    // Cache variant data on first access for better performance
    if (!this.variantData) {
      const jsonElement = this.querySelector('[data-variant-data]');
      if (jsonElement?.textContent) {
        try {
          this.variantData = JSON.parse(jsonElement.textContent);
          // Create lookup map for O(1) variant finding
          this.variantMap = new Map(this.variantData.map(variant => [variant.id, variant]));
        } catch (e) {
          console.error('Error parsing variant data:', e);
          this.variantData = [];
          this.variantMap = new Map();
        }
      } else {
        this.variantData = [];
        this.variantMap = new Map();
      }
    }
    return this.variantData;
  }

  enableLoading(line) {
    // Use Shopify's exact loading approach - disable entire cart
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }
    
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem) {
      const spinner = lineItem.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }
      lineItem.classList.add('loading');
    }
    this.updateStatus('');
  }

  disableLoading(line) {
    // Use Shopify's exact loading approach - re-enable entire cart
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
    
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem) {
      const spinner = lineItem.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.add('hidden');
      }
      lineItem.classList.remove('loading');
    }
  }

  showLoading(message) {
    this.updateStatus(message);
    const cartItem = this.closest('.cart-item');
    const spinner = cartItem.querySelector('.loading__spinner');
    
    if (spinner) {
      spinner.classList.remove('hidden');
    }
    cartItem.classList.add('loading');
  }

  showSuccess(message) {
    this.updateStatus(message);
    this.clearLoadingState();
  }

  showError(message) {
    this.updateStatus(message, 'error');
    this.clearLoadingState();
  }

  clearLoadingState() {
    const cartItem = this.closest('.cart-item');
    const spinner = cartItem.querySelector('.loading__spinner');
    
    if (spinner) {
      spinner.classList.add('hidden');
    }
    cartItem.classList.remove('loading');
  }

  updateStatus(message, type = '') {
    const statusElement = this.querySelector('.cart-variant-status');
    if (statusElement) {
      statusElement.textContent = message;
      statusElement.className = `cart-variant-status ${type}`;
    }
  }

  disableSelectors(disabled) {
    // Disable both selects and swatch inputs
    this.querySelectorAll('select').forEach(select => {
      select.disabled = disabled;
    });
    this.querySelectorAll('.cart-variant-swatch-input').forEach(input => {
      input.disabled = disabled;
    });
  }

  revertToOriginal() {
    // Revert selectors to original variant values
    const variants = this.getVariantData();
    const originalVariant = variants.find(v => v.id == this.currentVariantId);
    
    if (originalVariant) {
      this.querySelectorAll('.cart-variant-option').forEach((optionDiv, index) => {
        const originalValue = originalVariant.options[index];
        
        // Handle swatches
        const swatchInputs = optionDiv.querySelectorAll('.cart-variant-swatch-input');
        if (swatchInputs.length > 0) {
          swatchInputs.forEach(input => {
            input.checked = input.value === originalValue;
          });
        }
        
        // Handle dropdowns
        const select = optionDiv.querySelector('select');
        if (select) {
          select.value = originalValue;
        }
      });
    }
  }
}

// Initialize component
customElements.define('cart-variant-selector', CartVariantSelector);

// Additional DOM-ready patches for any existing instances
document.addEventListener('DOMContentLoaded', function() {
  // Apply patches when DOM is ready
  if (window.cartJSPatches) {
    window.cartJSPatches.applyPatches();
  }
  
  // Also patch any existing cart-items instances
  setTimeout(() => {
    document.querySelectorAll('cart-items').forEach(cartItems => {
      if (cartItems.setValidity) {
        const originalSetValidity = cartItems.setValidity;
        cartItems.setValidity = function(event, index, message) {
          try {
            if (event && event.target) {
              event.target.setCustomValidity(message);
              event.target.reportValidity();
              this.resetQuantityInput(index);
              if (event.target.tagName === 'INPUT' && typeof event.target.select === 'function') {
                event.target.select();
              }
            }
          } catch (e) {
            // Silently handle errors
          }
        };
      }
    });
  }, 150);
});